import { useState } from 'react';

interface HeaderProps {
  onOpenQuoteModal: () => void;
}

export default function Header({ onOpenQuoteModal }: HeaderProps) {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <header className="bg-white shadow-sm sticky top-0 z-50">
      <div className="container mx-auto px-4 py-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center">
            <h1 className="text-4xl font-bold text-gray-900 tracking-wide" style={{ fontFamily: '"Times New Roman", serif', letterSpacing: '0.1em' }}>
              EMA
            </h1>
            <span className="ml-3 text-sm text-gray-600 font-medium">Expert-Comptable</span>
          </div>
          
          <nav className="hidden md:flex space-x-8">
            <a href="#services" className="text-gray-700 hover:text-blue-900 transition-colors cursor-pointer">
              Nos Services
            </a>
            <a href="#avantages" className="text-gray-700 hover:text-blue-900 transition-colors cursor-pointer">
              Nos Avantages
            </a>
            <a href="#processus" className="text-gray-700 hover:text-blue-900 transition-colors cursor-pointer">
              Notre Processus
            </a>
            <a href="#temoignages" className="text-gray-700 hover:text-blue-900 transition-colors cursor-pointer">
              Témoignages
            </a>
            <a href="#contact" className="text-gray-700 hover:text-blue-900 transition-colors cursor-pointer">
              Contact
            </a>
          </nav>

          <button 
            onClick={onOpenQuoteModal}
            className="bg-black text-white px-6 py-2 rounded-lg hover:bg-gray-800 transition-colors whitespace-nowrap cursor-pointer hidden md:block"
          >
            Demander un devis
          </button>

          <button 
            className="md:hidden w-6 h-6 flex items-center justify-center cursor-pointer"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            <i className="ri-menu-line text-xl"></i>
          </button>
        </div>

        {isMenuOpen && (
          <div className="md:hidden mt-4 pb-4">
            <nav className="flex flex-col space-y-3">
              <a href="#services" className="text-gray-700 hover:text-blue-900 transition-colors cursor-pointer">
                Nos Services
              </a>
              <a href="#avantages" className="text-gray-700 hover:text-blue-900 transition-colors cursor-pointer">
                Nos Avantages
              </a>
              <a href="#processus" className="text-gray-700 hover:text-blue-900 transition-colors cursor-pointer">
                Notre Processus
              </a>
              <a href="#temoignages" className="text-gray-700 hover:text-blue-900 transition-colors cursor-pointer">
                Témoignages
              </a>
              <a href="#contact" className="text-gray-700 hover:text-blue-900 transition-colors cursor-pointer">
                Contact
              </a>
              <button 
                onClick={onOpenQuoteModal}
                className="bg-black text-white px-6 py-2 rounded-lg hover:bg-gray-800 transition-colors whitespace-nowrap cursor-pointer mt-4"
              >
                Demander un devis
              </button>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
}